// extracted by mini-css-extract-plugin
export var component = "SectionHeader-module--component--9VzsY";
export var title = "SectionHeader-module--title--HXn7d";